(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("tenantRegistrationQuestions", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/registration/tenantRegistrationQuestions/tenantRegistrationQuestions.component.html",
            controller: ["tenantFeaturesResource", "messageService", "$http", "$uibModal", "$timeout", "$window", TenantRegistrationQuestionsCtrl],
            controllerAs: "vm"
        };
        function TenantRegistrationQuestionsCtrl(tenantFeaturesResource, messageService, $http, $uibModal, $timeout, $window) {
            var vm = this;
            vm.siteFields = [];
            vm.downloadResponses = downloadResponses;
            load();
            ///////////////////////////////////////////////////////
            function load() {
                vm.loading = true;
                tenantFeaturesResource.getTenantRegistrationQuestionsViewModel(function (data) {
                    vm.siteFields = data.tenantRegistrationQuestions;
                    vm.loading = false;
                });
            }
            vm.sortableOptions = {
                handle: '.cursor-move',
                axis: "y",
                'ui-floating': false,
                start: function (e, ui) {
                    ui.placeholder.height(ui.helper.outerHeight());
                },
                stop: function () {
                    vm.saveOrder();
                }
            };
            vm.saveOrder = function () {
                var options = angular.copy(vm.siteFields);
                vm.animateLast = false;
                for (var i in options) {
                    if (options.hasOwnProperty(i)) {
                        options[i].order = parseInt(i) + 1;
                    }
                }
                tenantFeaturesResource.saveRegistrationQuestionsOrder({ tenantRegistrationQuestions: options }, function () {
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.saveState = function (question) {
                tenantFeaturesResource.saveRegistrationQuestionState(question, function () {
                    messageService.success("common.changesSaved");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.openQuestionModal = function (question) {
                var modalInstance = $uibModal.open({
                    templateUrl: "app/settings/registration/tenantRegistrationQuestions/tenantRegistrationQuestionsModalView.html",
                    controller: "TenantRegistrationQuestionsModalCtrl as vm",
                    size: "lg",
                    backdrop: "static",
                    animation: false,
                    resolve: {
                        question: function () {
                            return question;
                        },
                        isPreregistration: false
                    }
                });
                modalInstance.result.then(function () {
                    load();
                }).catch(angular.noop);
            };
            function downloadResponses() {
                if (vm.downloading)
                    return;
                vm.downloading = true;
                var url = "api/tenantFeatures/downloadUserResponses";
                //$http.post(url)
                $http.post(url, {}, { responseType: "arraybuffer" })
                    .then(function (response) {
                    $timeout(function () {
                        var date = new Date();
                        var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
                        var blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                        if ($window.navigator.userAgent.match("CriOS")) {
                            //1
                            //var blob = new Blob([response.data], { type: "application/octet-stream" }); //doesnt work
                            //var blob = new Blob([response.data], { "data": "attachment/csv;charset=utf-8;" }); //doesnt work
                            //var blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" }); //shows csv on new tab
                            var fileURL = (window.URL || window['webkitURL']).createObjectURL(blob);
                            var fileName = "UserResponses." + dateString + ".csv";
                            var downloadLink = document.createElement('a');
                            downloadLink.href = fileURL;
                            downloadLink.download = fileName;
                            document.body.appendChild(downloadLink);
                            downloadLink.click();
                            document.body.removeChild(downloadLink);
                            //2 - produces a document to download with the name "document"
                            //var blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                            //var reader = new FileReader();
                            //reader.onloadend = function () {
                            //	//$window.open(reader.result);
                            //	window.location.href = reader.result
                            //};
                            //reader.readAsDataURL(blob);
                        }
                        else {
                            window.saveAs(blob, "UserResponses." + dateString + ".csv");
                        }
                        vm.downloading = false;
                    });
                }, function () {
                    messageService.error("common.genericError");
                    vm.downloading = false;
                });
            }
        }
    });
})();
